export const ACCOUNT_ROUTE = "/home/account";

export const defaultWorkerToWorkplaceIncentive = {
  "Long Term Care": 100,
  Hospital: 100,
  School: 100,
  "Dental Clinic": 75,
  Pharmacy: 75,
};

export const WORKPLACE_REFERRAL_STATS_SCREEN_NAME = "Workplace Referral Stats";
export const WORKPLACE_AFFILIATE_STATS_SCREEN_NAME = "Affiliate Program Stats";
export const WORKPLACE_REFERRAL_SCREEN_NAME = "Refer Workplaces";
export const WORKPLACE_AFFILIATE_SCREEN_NAME = "Workplace Affiliate Program";
export const bonusBreakdownExpandedLocalStorageKey = "bonusBreakdownExpanded";
